export default __webpack_public_path__ + "static/media/12.bf1887e4.jpg";